import { Component, Input, OnInit } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'

export interface MenuDialogData {
  text: string
  role?: 'highlight' | 'destructive' | 'cancel' | 'disable'
  action: (() => Promise<void>) | (() => void)
}

/**
 * should use panel, dialog variable, 'custom-menu-dialog'
 */
@Component({
  selector: 'app-menu-dialog',
  templateUrl: './menu-dialog.component.html',
  styleUrls: ['./menu-dialog.component.scss'],
})
export class MenuDialogComponent implements OnInit {
  @Input() data: MenuDialogData[] = []

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {}

  onClickMenu(menu: MenuDialogData): void {
    if (menu.role === 'disable') {
      return
    }
    menu.action()
    this.modalService.dismiss()
  }
}
